// Reset password screen translations for all 11 supported languages

export const resetPasswordTranslations = {
  pt: {
    title: "Redefinir palavra-passe",
    description: "Crie uma nova palavra-passe para a sua conta.",
    new_password: "Nova palavra-passe",
    new_password_placeholder: "Crie uma palavra-passe segura",
    confirm_password: "Confirmar palavra-passe",
    confirm_password_placeholder: "Digite novamente a palavra-passe",
    password_requirements_title: "A palavra-passe deve conter:",
    requirement_min_length: "Pelo menos 8 caracteres",
    requirement_uppercase: "Pelo menos uma letra maiúscula",
    requirement_lowercase: "Pelo menos uma letra minúscula",
    requirement_number: "Pelo menos um número",
    passwords_match: "As palavras-passe coincidem",
    passwords_dont_match: "As palavras-passe não coincidem",
    submit_button: "Atualizar palavra-passe",
    submitting: "A atualizar...",
    back_to_login: "Voltar ao início de sessão",
    request_new_link: "Pedir novo link",
    error_required_fields: "Por favor preencha todos os campos obrigatórios",
    error_password_requirements: "A palavra-passe não cumpre os requisitos",
    error_passwords_dont_match: "As palavras-passe não coincidem",
    error_invalid_link: "O link é inválido ou expirou. Pede um novo link.",
    error_generic: "Não foi possível redefinir a palavra-passe. Tenta novamente.",
    success_title: "Palavra-passe atualizada",
    success_description: "A sua palavra-passe foi alterada com sucesso. Pode iniciar sessão.",
    success_button: "Entrar",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Precisa de ajuda?"
  },
  en: {
    title: "Reset your password",
    description: "Create a new password for your account.",
    new_password: "New password",
    new_password_placeholder: "Create a strong password",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Re-enter your password",
    password_requirements_title: "Password must contain:",
    requirement_min_length: "At least 8 characters",
    requirement_uppercase: "At least one uppercase letter",
    requirement_lowercase: "At least one lowercase letter",
    requirement_number: "At least one number",
    passwords_match: "Passwords match",
    passwords_dont_match: "Passwords don't match",
    submit_button: "Update password",
    submitting: "Updating...",
    back_to_login: "Back to sign in",
    request_new_link: "Request a new link",
    error_required_fields: "Please fill in all required fields",
    error_password_requirements: "Password doesn't meet requirements",
    error_passwords_dont_match: "Passwords don't match",
    error_invalid_link: "The link is invalid or expired. Request a new link.",
    error_generic: "We couldn't reset your password. Please try again.",
    success_title: "Password updated",
    success_description: "Your password has been updated. You can now sign in.",
    success_button: "Sign in",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Need help?"
  },
  es: {
    title: "Restablecer contraseña",
    description: "Crea una nueva contraseña para tu cuenta.",
    new_password: "Nueva contraseña",
    new_password_placeholder: "Crea una contraseña segura",
    confirm_password: "Confirmar contraseña",
    confirm_password_placeholder: "Vuelve a introducir tu contraseña",
    password_requirements_title: "La contraseña debe contener:",
    requirement_min_length: "Al menos 8 caracteres",
    requirement_uppercase: "Al menos una letra mayúscula",
    requirement_lowercase: "Al menos una letra minúscula",
    requirement_number: "Al menos un número",
    passwords_match: "Las contraseñas coinciden",
    passwords_dont_match: "Las contraseñas no coinciden",
    submit_button: "Actualizar contraseña",
    submitting: "Actualizando...",
    back_to_login: "Volver al inicio de sesión",
    request_new_link: "Solicitar un nuevo enlace",
    error_required_fields: "Por favor completa todos los campos obligatorios",
    error_password_requirements: "La contraseña no cumple los requisitos",
    error_passwords_dont_match: "Las contraseñas no coinciden",
    error_invalid_link: "El enlace es inválido o ha caducado. Solicita uno nuevo.",
    error_generic: "No pudimos restablecer tu contraseña. Inténtalo de nuevo.",
    success_title: "Contraseña actualizada",
    success_description: "Tu contraseña se ha actualizado. Ya puedes iniciar sesión.",
    success_button: "Iniciar sesión",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "¿Necesitas ayuda?"
  },
  fr: {
    title: "Réinitialiser le mot de passe",
    description: "Créez un nouveau mot de passe pour votre compte.",
    new_password: "Nouveau mot de passe",
    new_password_placeholder: "Créez un mot de passe fort",
    confirm_password: "Confirmer le mot de passe",
    confirm_password_placeholder: "Resaisissez votre mot de passe",
    password_requirements_title: "Le mot de passe doit contenir:",
    requirement_min_length: "Au moins 8 caractères",
    requirement_uppercase: "Au moins une lettre majuscule",
    requirement_lowercase: "Au moins une lettre minuscule",
    requirement_number: "Au moins un chiffre",
    passwords_match: "Les mots de passe correspondent",
    passwords_dont_match: "Les mots de passe ne correspondent pas",
    submit_button: "Mettre à jour le mot de passe",
    submitting: "Mise à jour...",
    back_to_login: "Retour à la connexion",
    request_new_link: "Demander un nouveau lien",
    error_required_fields: "Veuillez remplir tous les champs obligatoires",
    error_password_requirements: "Le mot de passe ne respecte pas les exigences",
    error_passwords_dont_match: "Les mots de passe ne correspondent pas",
    error_invalid_link: "Le lien est invalide ou expiré. Demandez un nouveau lien.",
    error_generic: "Impossible de réinitialiser le mot de passe. Réessayez.",
    success_title: "Mot de passe mis à jour",
    success_description: "Votre mot de passe a été mis à jour. Vous pouvez vous connecter.",
    success_button: "Se connecter",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Besoin d'aide?"
  },
  de: {
    title: "Passwort zurücksetzen",
    description: "Erstellen Sie ein neues Passwort für Ihr Konto.",
    new_password: "Neues Passwort",
    new_password_placeholder: "Erstellen Sie ein starkes Passwort",
    confirm_password: "Passwort bestätigen",
    confirm_password_placeholder: "Geben Sie Ihr Passwort erneut ein",
    password_requirements_title: "Das Passwort muss enthalten:",
    requirement_min_length: "Mindestens 8 Zeichen",
    requirement_uppercase: "Mindestens einen Großbuchstaben",
    requirement_lowercase: "Mindestens einen Kleinbuchstaben",
    requirement_number: "Mindestens eine Zahl",
    passwords_match: "Passwörter stimmen überein",
    passwords_dont_match: "Passwörter stimmen nicht überein",
    submit_button: "Passwort aktualisieren",
    submitting: "Wird aktualisiert...",
    back_to_login: "Zurück zur Anmeldung",
    request_new_link: "Neuen Link anfordern",
    error_required_fields: "Bitte füllen Sie alle erforderlichen Felder aus",
    error_password_requirements: "Passwort erfüllt nicht die Anforderungen",
    error_passwords_dont_match: "Passwörter stimmen nicht überein",
    error_invalid_link: "Der Link ist ungültig oder abgelaufen. Fordern Sie einen neuen an.",
    error_generic: "Passwort konnte nicht zurückgesetzt werden. Bitte erneut versuchen.",
    success_title: "Passwort aktualisiert",
    success_description: "Ihr Passwort wurde aktualisiert. Sie können sich jetzt anmelden.",
    success_button: "Anmelden",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brauchen Sie Hilfe?"
  },
  it: {
    title: "Reimposta la password",
    description: "Crea una nuova password per il tuo account.",
    new_password: "Nuova password",
    new_password_placeholder: "Crea una password sicura",
    confirm_password: "Conferma password",
    confirm_password_placeholder: "Reinserisci la password",
    password_requirements_title: "La password deve contenere:",
    requirement_min_length: "Almeno 8 caratteri",
    requirement_uppercase: "Almeno una lettera maiuscola",
    requirement_lowercase: "Almeno una lettera minuscola",
    requirement_number: "Almeno un numero",
    passwords_match: "Le password coincidono",
    passwords_dont_match: "Le password non coincidono",
    submit_button: "Aggiorna password",
    submitting: "Aggiornamento...",
    back_to_login: "Torna all'accesso",
    request_new_link: "Richiedi un nuovo link",
    error_required_fields: "Compila tutti i campi obbligatori",
    error_password_requirements: "La password non soddisfa i requisiti",
    error_passwords_dont_match: "Le password non coincidono",
    error_invalid_link: "Il link non è valido o è scaduto. Richiedine uno nuovo.",
    error_generic: "Non è stato possibile reimpostare la password. Riprova.",
    success_title: "Password aggiornata",
    success_description: "La tua password è stata aggiornata. Ora puoi accedere.",
    success_button: "Accedi",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hai bisogno di aiuto?"
  },
  nl: {
    title: "Wachtwoord opnieuw instellen",
    description: "Maak een nieuw wachtwoord voor je account.",
    new_password: "Nieuw wachtwoord",
    new_password_placeholder: "Maak een sterk wachtwoord",
    confirm_password: "Bevestig wachtwoord",
    confirm_password_placeholder: "Voer je wachtwoord opnieuw in",
    password_requirements_title: "Wachtwoord moet bevatten:",
    requirement_min_length: "Minimaal 8 tekens",
    requirement_uppercase: "Minstens één hoofdletter",
    requirement_lowercase: "Minstens één kleine letter",
    requirement_number: "Minstens één nummer",
    passwords_match: "Wachtwoorden komen overeen",
    passwords_dont_match: "Wachtwoorden komen niet overeen",
    submit_button: "Wachtwoord bijwerken",
    submitting: "Bijwerken...",
    back_to_login: "Terug naar inloggen",
    request_new_link: "Nieuw link aanvragen",
    error_required_fields: "Vul alle verplichte velden in",
    error_password_requirements: "Wachtwoord voldoet niet aan de eisen",
    error_passwords_dont_match: "Wachtwoorden komen niet overeen",
    error_invalid_link: "De link is ongeldig of verlopen. Vraag een nieuwe aan.",
    error_generic: "We konden je wachtwoord niet resetten. Probeer het opnieuw.",
    success_title: "Wachtwoord bijgewerkt",
    success_description: "Je wachtwoord is bijgewerkt. Je kunt nu inloggen.",
    success_button: "Inloggen",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hulp nodig?"
  },
  sv: {
    title: "Återställ lösenord",
    description: "Skapa ett nytt lösenord för ditt konto.",
    new_password: "Nytt lösenord",
    new_password_placeholder: "Skapa ett starkt lösenord",
    confirm_password: "Bekräfta lösenord",
    confirm_password_placeholder: "Skriv in lösenordet igen",
    password_requirements_title: "Lösenordet måste innehålla:",
    requirement_min_length: "Minst 8 tecken",
    requirement_uppercase: "Minst en versal",
    requirement_lowercase: "Minst en gemen",
    requirement_number: "Minst en siffra",
    passwords_match: "Lösenorden matchar",
    passwords_dont_match: "Lösenorden matchar inte",
    submit_button: "Uppdatera lösenord",
    submitting: "Uppdaterar...",
    back_to_login: "Tillbaka till inloggning",
    request_new_link: "Be om ny länk",
    error_required_fields: "Fyll i alla obligatoriska fält",
    error_password_requirements: "Lösenordet uppfyller inte kraven",
    error_passwords_dont_match: "Lösenorden matchar inte",
    error_invalid_link: "Länken är ogiltig eller har gått ut. Be om en ny.",
    error_generic: "Vi kunde inte återställa lösenordet. Försök igen.",
    success_title: "Lösenord uppdaterat",
    success_description: "Ditt lösenord har uppdaterats. Du kan nu logga in.",
    success_button: "Logga in",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Behöver du hjälp?"
  },
  da: {
    title: "Nulstil adgangskode",
    description: "Opret en ny adgangskode til din konto.",
    new_password: "Ny adgangskode",
    new_password_placeholder: "Opret en stærk adgangskode",
    confirm_password: "Bekræft adgangskode",
    confirm_password_placeholder: "Indtast adgangskoden igen",
    password_requirements_title: "Adgangskoden skal indeholde:",
    requirement_min_length: "Mindst 8 tegn",
    requirement_uppercase: "Mindst ét stort bogstav",
    requirement_lowercase: "Mindst ét lille bogstav",
    requirement_number: "Mindst ét tal",
    passwords_match: "Adgangskoderne matcher",
    passwords_dont_match: "Adgangskoderne matcher ikke",
    submit_button: "Opdater adgangskode",
    submitting: "Opdaterer...",
    back_to_login: "Tilbage til login",
    request_new_link: "Anmod om nyt link",
    error_required_fields: "Udfyld alle obligatoriske felter",
    error_password_requirements: "Adgangskoden opfylder ikke kravene",
    error_passwords_dont_match: "Adgangskoderne matcher ikke",
    error_invalid_link: "Linket er ugyldigt eller udløbet. Anmod om et nyt.",
    error_generic: "Vi kunne ikke nulstille adgangskoden. Prøv igen.",
    success_title: "Adgangskode opdateret",
    success_description: "Din adgangskode er opdateret. Du kan nu logge ind.",
    success_button: "Log ind",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brug for hjælp?"
  },
  fi: {
    title: "Palauta salasana",
    description: "Luo uusi salasana tilillesi.",
    new_password: "Uusi salasana",
    new_password_placeholder: "Luo vahva salasana",
    confirm_password: "Vahvista salasana",
    confirm_password_placeholder: "Syötä salasana uudelleen",
    password_requirements_title: "Salasanan tulee sisältää:",
    requirement_min_length: "Vähintään 8 merkkiä",
    requirement_uppercase: "Vähintään yksi iso kirjain",
    requirement_lowercase: "Vähintään yksi pieni kirjain",
    requirement_number: "Vähintään yksi numero",
    passwords_match: "Salasanat täsmäävät",
    passwords_dont_match: "Salasanat eivät täsmää",
    submit_button: "Päivitä salasana",
    submitting: "Päivitetään...",
    back_to_login: "Takaisin kirjautumiseen",
    request_new_link: "Pyydä uusi linkki",
    error_required_fields: "Täytä kaikki pakolliset kentät",
    error_password_requirements: "Salasana ei täytä vaatimuksia",
    error_passwords_dont_match: "Salasanat eivät täsmää",
    error_invalid_link: "Linkki on virheellinen tai vanhentunut. Pyydä uusi linkki.",
    error_generic: "Salasanan palautus epäonnistui. Yritä uudelleen.",
    success_title: "Salasana päivitetty",
    success_description: "Salasanasi on päivitetty. Voit nyt kirjautua sisään.",
    success_button: "Kirjaudu sisään",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Tarvitsetko apua?"
  },
  et: {
    title: "Parooli lähtestamine",
    description: "Loo oma kontole uus parool.",
    new_password: "Uus parool",
    new_password_placeholder: "Loo tugev parool",
    confirm_password: "Kinnita parool",
    confirm_password_placeholder: "Sisesta parool uuesti",
    password_requirements_title: "Parool peab sisaldama:",
    requirement_min_length: "Vähemalt 8 märki",
    requirement_uppercase: "Vähemalt üks suur täht",
    requirement_lowercase: "Vähemalt üks väike täht",
    requirement_number: "Vähemalt üks number",
    passwords_match: "Paroolid ühtivad",
    passwords_dont_match: "Paroolid ei ühti",
    submit_button: "Uuenda parooli",
    submitting: "Uuendamine...",
    back_to_login: "Tagasi sisselogimisele",
    request_new_link: "Küsi uus link",
    error_required_fields: "Palun täida kõik kohustuslikud väljad",
    error_password_requirements: "Parool ei vasta nõuetele",
    error_passwords_dont_match: "Paroolid ei ühti",
    error_invalid_link: "Link on vigane või aegunud. Küsi uus link.",
    error_generic: "Parooli ei õnnestunud lähtestada. Proovi uuesti.",
    success_title: "Parool uuendatud",
    success_description: "Sinu parool on uuendatud. Saad nüüd sisse logida.",
    success_button: "Logi sisse",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Vajad abi?"
  },
};
